@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.additional_data.title' | translate }}
    </p>

    <div class="x-input-label">
      {{
        'request_form.common.additional_data.shipment_docs_address' | translate
      }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ShipmentDocsAddress"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
    <div class="x-input-label">
      {{ 'request_form.common.additional_data.timezone' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.Timezone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
  </div>
</form>
